import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getTopper } from "../../Service/Api";
import LazyLoad from "react-lazyload";
import Breadcrumb from "../../Component/Breadcrumb";

function ISCToppersXII() {
  const [search, setSearch] = useState("");
  const currentYear = new Date().getFullYear();
  const defaultSessionYear = `${currentYear - 1}-${currentYear}`;
  const [year, setYear] = useState(defaultSessionYear);

  // ✅ Fetch toppers (no isLoading / isError)
  const { data: toppers = [] } = useQuery({
    queryKey: ["topperList"],
    queryFn: getTopper,
  });

  // ✅ Filter toppers for Class XII
  const filteredToppers = toppers.filter((item) => {
    const matchesClass = item.class === "XII";
    const matchesYear = item.sessionYear?.toString().includes(year.toString());
    const matchesSearch =
      item.name?.toLowerCase().includes(search.toLowerCase()) ||
      item.stream?.toLowerCase().includes(search.toLowerCase());
    return matchesClass && matchesYear && matchesSearch;
  });

  // ✅ Unique session years for dropdown
  const uniqueYears = Array.from(new Set(toppers.map((t) => t.sessionYear)))
    .sort()
    .reverse();

  useEffect(() => {
    document.title = "ISCToppers";
  }, []);

  return (
    <>
      <Breadcrumb>Results / ISCE</Breadcrumb>

      <div className="innersec container my-5" id="topper_inner_sec">
        <div className="row">
          <div className="col-lg-12">
            <h1>ISC Toppers</h1>
          </div>
        </div>

        {/* ===== Filter Bar ===== */}
        <div className="filter-bar mb-5 p-3 rounded">
          <div className="row align-items-center g-3">
            <div className="col-md-4 col-sm-6">
              <span className="fw-semibold text-secondary">
                Total Count:{" "}
                <span className="total_count_numb">
                  {filteredToppers.length}
                </span>
              </span>
            </div>

            <div className="col-md-4 col-sm-6">
              <select
                className="form-select filter-select"
                value={year}
                onChange={(e) => setYear(e.target.value)}
              >
                {uniqueYears.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4 col-sm-6">
              <input
                type="text"
                className="form-control filter-search"
                placeholder="Search by name or stream..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* ===== Toppers Grid ===== */}
        <div className="row">
          {filteredToppers.length > 0 ? (
            filteredToppers
              .sort((a, b) => {
                const divA =
                  parseFloat(a.division?.toString().replace("%", "")) || 0;
                const divB =
                  parseFloat(b.division?.toString().replace("%", "")) || 0;
                return divB - divA;
              })
              .map((topper, index) => (
                <div
                  className="col-xl-3 col-lg-4 col-md-4 col-6"
                  key={topper._id || index}
                >
                  <div className="toppers-inner">
                    <LazyLoad
                      offset={10}
                      placeholder={
                        <img
                          src="https://webapi.entab.info/api/image/SJSKBUP/public/Images/trophy.png"
                          alt="Loading..."
                          className="img-fluid"
                        />
                      }
                    >
                      <img
                        src={
                          topper.attachments && topper.attachments[0]
                            ? `https://webapi.entab.info/api/image/${topper.attachments[0]}`
                            : "https://webapi.entab.info/api/image/SJSKBUP/public/Images/trophy.png"
                        }
                        className="img-fluid"
                        alt={topper.name}
                      />
                    </LazyLoad>

                    <h3>{topper.name}</h3>
                    <p>{topper.stream || "Stream not specified"}</p>
                    <h5>{topper.division}</h5>
                  </div>
                </div>
              ))
          ) : (
            // ✅ Fallback when no toppers available
            <div className="col-xl-3 col-lg-4 col-md-4 col-6">
              <div className="toppers-inner">
                <LazyLoad
                  offset={10}
                  placeholder={
                    <img
                      src="https://webapi.entab.info/api/image/SJSKBUP/public/Images/trophy.png"
                      alt="Loading..."
                      className="img-fluid"
                    />
                  }
                >
                  <img
                    src={
                      "https://webapi.entab.info/api/image/SJSKBUP/public/Images/trophy.png"
                    }
                    className="img-fluid"
                  />
                </LazyLoad>
                <h3>Name</h3>
                <p>Stream</p>
                <h5>%</h5>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ISCToppersXII;
